export const formatSpaceUsageItem = (spaceUsageItem, isSupplier) => {

    const {
      calendarDate,
      totalSpacesBooked,
      maxInventoryCount,
      overageSpacesChargedCount,
      locationName,
      buyerCompanyName,
      supplierCompanyName,
      overageInvoiceNumbers,
      bookingNumbers
    } = spaceUsageItem;

    const calculateOveragesSpaces = () => {
        let {maxInventoryCount, totalSpacesBooked} = spaceUsageItem;
        return maxInventoryCount > totalSpacesBooked ? maxInventoryCount - totalSpacesBooked : 0;
    };

    const calculateUnchargedOverages = () => {
        let overagesSpaces = calculateOveragesSpaces();
        let {overageSpacesChargedCount} = spaceUsageItem;
        return  overagesSpaces - overageSpacesChargedCount;
    };

    const prefix = {
        date: calendarDate,
        bookedSpaces: totalSpacesBooked,
        maxInventory: maxInventoryCount,
        overageSpaces: calculateOveragesSpaces(),
        invoicedOverages: overageSpacesChargedCount,
        unchargedOverages: calculateUnchargedOverages(),
        location: locationName,
    }

    const suffix = {
        overageInvoices: overageInvoiceNumbers,
        bookings: totalSpacesBooked > 0 ? bookingNumbers : '',
    }

    if (isSupplier) {
        return {
            ...prefix,
            buyer: buyerCompanyName,
            ...suffix,
        }
    }

    return {
        ...prefix,
        supplier: supplierCompanyName,
        ...suffix,
    };
}

export const sortByFields = [
    {label: "Supplier", value: "SUPPLIER_COMPANY_NAME"},
    {label: "Bookings", value: "BOOKING_NUMBERS"},
    {label: "Location", value: "LOCATION_NAME"},
    {label: "Overage Invoices", value: "OVERAGE_INVOICE_NUMBERS"},
    {label: "Booked Spaces", value: "TOTAL_SPACES_BOOKED"},
    {label: "Date", value: "CALENDAR_DATE"},
    {label: "Max Inventory", value: "MAX_INVENTORY_COUNT"},
    {label: "Charged Overages", value: "OVERAGE_SPACES_CHARGED_COUNT"},
];
